import React from "react";
import Navbar from "./navbar/";
import Draw from "./draw";
import Dialog from "./dialog/";
import Paypal from "./paypal/";

export default () => (
  <div>
    <Navbar title="Reproduction / Quadrillage" />
    <div className="container">
      <Draw />
    </div>
    <Dialog />
    <Paypal />
  </div>
);
